import store from "../../index";
import calendarAPIService from "./calendarAPIService";
import { SLOT_INTERVAL_MS } from "../../../constants_calendar";

/**
 * First step in refactoring calendar to be more optimized. Currently five different
 * requests are made to the server during initial load that could all be a singular
 * request. This also allow improving optimization from a single place.
 */

/**
 * Loads data from database and sets it to Vuex
 * @param {String} userID current user's ID
 * @param {Number/String} startDateMS -- start date (rounded down to nearest slot, inclusive)
 * @param {Number/String} endDateMS -- end date (rounded up to nearest slot, exclusive)
 */
async function initCalendarData(userID, dataStart, dataEnd) {
  try {
    /* Set data for view */
    const promiseArray = [];
    promiseArray.push(store.dispatch("calendar/addDateTimeRange", { rangeStart: dataStart, rangeEnd: dataEnd }));
    promiseArray.push(store.dispatch("matchPool/addDateTimeRange", { rangeStart: dataStart, rangeEnd: dataEnd }));
    await Promise.all(promiseArray);

    /* Get initial calendar data */
    await getInitialCalendarData(userID, dataStart, dataEnd);
  } catch (error) {
    console.error("@initCalendarData error: ", error);
  }
}

/**
 * Loads data from database and sets it to Vuex
 * @param {String} userID current user's ID
 * @param {Number/String} startDateMS -- start date (rounded down to nearest slot, inclusive)
 * @param {Number/String} endDateMS -- end date (rounded up to nearest slot, exclusive)
 */
async function getInitialCalendarData(userID, startDateMS, endDateMS) {
  startDateMS = Math.floor(startDateMS / SLOT_INTERVAL_MS) * SLOT_INTERVAL_MS;
  endDateMS = Math.ceil(endDateMS / SLOT_INTERVAL_MS) * SLOT_INTERVAL_MS;
  try {
    const initialLoadData = await calendarAPIService.loadInitialCalendarData(userID, startDateMS, endDateMS);
    if (!initialLoadData) throw new Error("Failed to get initial calendar data.");

    const { currentUserData, pastSessions, upcomingSessions, matchablePeople, blockedExcludedIDs } = initialLoadData;

    /* Set the current user's initial data */
    if (currentUserData) {
      await store.dispatch("calendar/setCurrentUserData", currentUserData);
    }

    /* Set past sessions */
    store.dispatch("pastMatches/addFromDB", pastSessions);

    /* Set upcoming sessions */
    store.dispatch("upcomingMatches/addFromDB", {
      dataStart: startDateMS,
      dataEnd: endDateMS,
      upcomingSessions: upcomingSessions,
    });

    /* Set available unmatched sessions */
    store.dispatch("matchPool/addFromDB", {
      dataStart: startDateMS,
      dataEnd: endDateMS,
      matchablePeople: matchablePeople,
    });

    /* Set blocked-excluded IDs */
    store.dispatch("calendar/setBlockedExcludedIDs", blockedExcludedIDs);

    /* Set any notices for the user (NEEDS RE-ENGINEERING) */
    /* if (notices) {
      store.dispatch("notices/setNotices", notices);
    } */
  } catch (error) {
    console.error("@getInitialCalendarData error: ", error);
    return;
  }
}

export default initCalendarData;
